<button [disabled]="disabled || loading" class="{{ class }}" (click)="onClick()">
    <p>{{ text }}</p>
    @if (loading) {
        <div class="spinner-container">
            <div class="spinner"></div>
        </div>
    }
</button>
